export default __webpack_public_path__ + "static/media/avatarHotel.a9ebabd6.png";